import { useTranslation } from 'react-i18next';
import InputEmail from '../../components/common/Input/inputEmail';
import InputText from '../../components/common/Input/inputText';
import FilterBodyComponent from "../../components/rGlobalComponents/FilterBodyComponent";
import { useHandleInputChange } from '../../hook/useHandleInputChange';
import '../../style/filter.css';
import { initialState } from './initialStates/create';
import useFormStateByQuery from '../../hook/useFormStateByQuery';
import { useQuery } from '../../hook/useQuery';

const Filter = ({ handleFilterData }) => {
    const { t } = useTranslation();
    const { formStateByQuery } = useFormStateByQuery(initialState);
    const { formState, handleInputChange, setFormState } = useHandleInputChange(formStateByQuery);
    const { getQueryString, resetFilterUrl } = useQuery(formState);

    const handleFilter = async (e) => {
        await getQueryString();
        e.preventDefault();
        handleFilterData()
    };

    const handleRestFilter = (e) => {
        e.preventDefault();
        setFormState(initialState)
        resetFilterUrl();
        handleFilterData(null);
    };

    return (
        <FilterBodyComponent handleFilter={handleFilter} handleRestFilter={handleRestFilter} formState={formState}>
            <InputText
                className='col-md-2'
                name="name"
                label={t('properties.name')}
                value={formState?.name}
                onChange={handleInputChange}
            />

            <InputText
                className='col-md-2'
                name="surname"
                label={t('properties.surname')}
                value={formState?.surname}
                onChange={handleInputChange}
            />

            <InputEmail
                className='col-md-2'
                name="email"
                label={t('properties.email')}
                value={formState?.email}
                onChange={handleInputChange}
            />
        </FilterBodyComponent >
    );
};

export default Filter;